import { Component, OnInit, ViewChild } from '@angular/core';
import { Constants } from 'src/app/constants/constants';
import { ToastService } from 'src/app/service/toast.service';
import { UtilService } from 'src/app/service/util.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ApiService } from 'src/app/service/api.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'payment-settings',
  templateUrl: './payment-settings.component.html',
  styleUrls: ['./payment-settings.component.scss']
})
export class PaymentSettingsComponent implements OnInit {

  paymentTypes: Array<string> = ["ACH", "CARD"];
  paymentSettings: Array<string> = ["AUTO", "MANUAL"];

  accountPaymentSetting: any;
  initialAccountPaymentSetting: any;
  selectedPaymentInstrument: any;
  defaultPaymentInstrumentId: string;
  defaultPaymentSetting: string;
  isEditPaymentInstrumentsEnabled: boolean = false;
  isEditPaymentSettingEnabled: boolean = false;

  deleteModalBodyText: string = "Are you sure want to delete?";
  showErrorMessage: boolean = false;
  // accountCategory: string;
  @ViewChild('paymentInstrumentsForm') public paymentInstrumentsForm: NgForm;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    // this.accountCategory = this.apiService.accountDetail.category;
    // this.getAccountPaymentSetting();
  }

  getAccountPaymentSetting() {
    this.accountPaymentSetting = null;
    this.utilService.showSpinner();
    this.apiService.getAccountPaymentSetting().then((data) => {
      this.utilService.hideSpinner();
      console.log("account payment setting data::", data);
      this.accountPaymentSetting = data;
      this.initialAccountPaymentSetting = JSON.parse(JSON.stringify(this.accountPaymentSetting));
      this.setDefaultSettings();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountPaymentSetting();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  setDefaultSettings() {
    if(this.accountPaymentSetting && this.accountPaymentSetting.paymentInstruments) {
      this.accountPaymentSetting.paymentInstruments.forEach(instrument => {
        if(instrument.isDefault) this.defaultPaymentInstrumentId = instrument.instrumentId;
      });

      if (this.accountPaymentSetting.paymentInstruments.length < 1)
        this.isEditPaymentInstrumentsEnabled = false;
        
    } else {
      this.accountPaymentSetting = {
        paymentInstruments: [],
        paymentSetting: this.paymentSettings[1]
      }
    }
    this.defaultPaymentSetting = this.accountPaymentSetting.paymentSetting;
    console.log("Default payment instrument id:", this.defaultPaymentInstrumentId, "\nSetting: ", this.defaultPaymentSetting);
  }
  
  getLastFourDigit(account: string) {
    return account.substr(account.length - 4);
  }

  getPaymentIcon(cardType: string) {
    if(Constants.PAYMENT_CARDS_LOGO.has(cardType)) {
      return Constants.PAYMENT_CARDS_LOGO.get(cardType);
    }
    return null;
  }

  onDeletePaymentInstrument1(instrument, index) {
    this.accountPaymentSetting.paymentInstruments.splice(index, 1);
    // this.domainForm.getControl(this.dom).markAsDirty();
  }

  onDeletePaymentInstrument(instrument) {
    this.showErrorMessage = false;

    let instrumentSummary = instrument.mode + " ending in ";
    instrumentSummary += instrument.mode == this.paymentTypes[0] ? this.getLastFourDigit(instrument.summary.accountNo) : this.getLastFourDigit(instrument.summary.cardNo);

    this.deleteModalBodyText = "Confirm deleting '" + instrumentSummary + "'?";
    this.selectedPaymentInstrument = instrument;
    if(this.accountPaymentSetting.paymentSetting == this.paymentSettings[0]) {
      if(this.accountPaymentSetting.paymentInstruments &&
         (this.accountPaymentSetting.paymentInstruments.length == 1 || this.selectedPaymentInstrument.isDefault)) {
        this.showErrorMessage = true;
        this.deleteModalBodyText = "Default payment instrument cannot be deleted when Auto-Pay is enabled";
      } 
      // else if(this.accountPaymentSetting.paymentInstruments && this.selectedPaymentInstrument.isDefault) {
      //   this.showErrorMessage = true;
      //   this.deleteModalBodyText = "'" + instrumentSummary + "' is set as default payment instrument for Auto Payment. Change the payment mode to 'Manual' or set another instrument as default.";
      // }
    }
    document.getElementById("openDeletePaymentInstrumentModal").click();
  }



  confirmDelete() {
    this.deletePaymentInstrument(this.selectedPaymentInstrument.instrumentId);
  }

  cancelDelete() { }
  
  deletePaymentInstrument(instrumentId: string) {
    this.utilService.showSpinner();
    this.apiService.deletePaymentInstrument(instrumentId).then((data) => {
      this.utilService.hideSpinner();
      console.log("delete payment instrument response::", data);
      this.toast.showSuccess("Payment instrument deleted successfully.")
      document.getElementById("closeDeletePaymentInstrumentModal").click();
      this.getAccountPaymentSetting();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deletePaymentInstrument(instrumentId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onCheckedChange(instrumentIndex, status) {
    // console.log(instrumentId, status);
    var updatePaymentInstruments = new Array();
    if(status || (!status && this.accountPaymentSetting.paymentSetting == this.paymentSettings[0])) {

      for(var index = 0; index < this.accountPaymentSetting.paymentInstruments.length; index++ ) {
        var instrument = this.accountPaymentSetting.paymentInstruments[index];
        if(index == instrumentIndex) {
          instrument.isDefault = true;
        } else {
          instrument.isDefault = false;
        }
        updatePaymentInstruments.push(instrument);
      }

      // this.accountPaymentSetting.paymentInstruments.forEach(instrument => {
      //   if(instrument.instrumentId == instrumentId) instrument.isDefault = true;
      //   else instrument.isDefault = false;
      //   updatePaymentInstruments.push(instrument);
      // });
    }
     else {
        updatePaymentInstruments = this.accountPaymentSetting.paymentInstruments; 
    }
    this.accountPaymentSetting.paymentInstruments = JSON.parse(JSON.stringify(updatePaymentInstruments));
  }

   confirmUpdate() {
    var selectedPreferredPaymentMode = this.defaultPaymentInstrumentId;
    if(this.accountPaymentSetting && this.accountPaymentSetting.paymentInstruments) {
      this.accountPaymentSetting.paymentInstruments.forEach(instrument => {
        if(instrument.isDefault) selectedPreferredPaymentMode = instrument.instrumentId;
      });
    }

    if(selectedPreferredPaymentMode == this.defaultPaymentInstrumentId && this.accountPaymentSetting.paymentSetting == this.defaultPaymentSetting) {
      document.getElementById("closeUpdatePaymentInstrumentModal").click();
      return;
    }

    if(this.accountPaymentSetting.paymentSetting == this.paymentSettings[0] && this.accountPaymentSetting.paymentInstruments.length < 1) {
      this.accountPaymentSetting.paymentSetting = this.paymentSettings[1];
      this.toast.showInfo("Atleast one payment instrument required to set Auto Payment");
      document.getElementById("closeUpdatePaymentInstrumentModal").click();
      return;
    }

    var payload = {
      "defaultInstrumentId": selectedPreferredPaymentMode,
      "paymentSetting": this.accountPaymentSetting.paymentSetting
    }
    console.log("update payload:", payload);
    this.updateAccountPaymentSetting(payload);
  }

  cancelUpdate() {
    this.isEditPaymentInstrumentsEnabled = false;
    this.resetInstruments();
  }

  // updatePaymentSetting() {
  //   var payload = {
  //     "paymentSetting": this.accountPaymentSetting.paymentSetting
  //   }
  //   this.updateAccountPaymentSetting(payload);
  // }

  updateAccountPaymentSetting(payload) {
    this.utilService.showSpinner();
    this.apiService.updateAccountPaymentSetting(payload).then((data) => {
      this.utilService.hideSpinner();
      // console.log("Update payment settings response::", data);
      this.toast.showSuccess("Payment profile updated successfully.");
      // document.getElementById("closePaymentSettingsModal").click();
      this.accountPaymentSetting = data;
      this.initialAccountPaymentSetting = JSON.parse(JSON.stringify(this.accountPaymentSetting));
      document.getElementById("closeUpdatePaymentInstrumentModal").click();
      this.setDefaultSettings();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateAccountPaymentSetting(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  enableEditingPaymentInstruments() {

    if(this.isEditPaymentInstrumentsEnabled && this.paymentInstrumentsForm.dirty) {
      document.getElementById("openUpdatePaymentInstrumentModal").click();
      return;
    }

    this.isEditPaymentInstrumentsEnabled = !this.isEditPaymentInstrumentsEnabled;
    this.resetInstruments();

    if(this.isEditPaymentInstrumentsEnabled) {
      this.isEditPaymentSettingEnabled = false;
      this.resetPaymentSetting();
    }
  }

  resetInstruments() {
    if (!this.isEditPaymentInstrumentsEnabled) {
      this.accountPaymentSetting.paymentInstruments = JSON.parse(JSON.stringify(this.initialAccountPaymentSetting.paymentInstruments));
    }
  }

  enableEditingPaymentSetting() {

    if(this.isEditPaymentInstrumentsEnabled && this.paymentInstrumentsForm.dirty) {
      document.getElementById("openUpdatePaymentInstrumentModal").click();
      return;
    } else this.isEditPaymentInstrumentsEnabled = false;

    this.isEditPaymentSettingEnabled = !this.isEditPaymentSettingEnabled;
    this.resetPaymentSetting();
  }

  resetPaymentSetting() {
    if (!this.isEditPaymentSettingEnabled) {
      this.accountPaymentSetting.paymentSetting = this.initialAccountPaymentSetting.paymentSetting;
    }
  }
  
  closePaymentProfile() {
    this.isEditPaymentSettingEnabled = false;
    this.isEditPaymentInstrumentsEnabled = false;
  }

  isShowDelete(instrument) : boolean {
    
    if (!instrument.isDefault ||
      (this.initialAccountPaymentSetting.paymentSetting == this.paymentSettings[1]
        && this.initialAccountPaymentSetting.paymentInstruments.length == 1)) {
        return true;
    }
  
  
    return false;
  }
}
